import type { CustomControlData } from '../../../common/interfaces/customControlData';
import type { GetProcessActivitiesResponseBody } from '../../../common/interfaces/IProcessActivity';
import { fetchJson } from '../../../frontend/store/fetch';

export async function getProcessActivities<T = CustomControlData>(): Promise<GetProcessActivitiesResponseBody<T>> {
    const result = await fetchJson(`/api/patient/processActivities`, 'GET');

    return result.json;
}
